export default __webpack_public_path__ + "static/media/stepper-spacing.bb330549.svg";